import styled from 'styled-components';
import css from '@styled-system/css';

const Anchor = styled('span')(
  css({
    display: 'block',
    position: 'relative',
    top: [-64, null, null, -80],
    visibility: 'hidden',
  })
);

export default Anchor;
